import axios, { AxiosInstance } from 'axios';
import config from 'config';
import { autoLogout, injectToken, updateToken } from './RestClient';
import { GoogleMapsUsageEvent } from 'core/googleMapsUsage/GoogleMapsUsageEvent';

// POST buffered Google Maps usage events. BE responds with `{ accepted,
// dropped }`; `dropped > 0` means the BE per-channelGroup rate limit shed
// events.

export type PostGoogleMapsUsageResponse = {
  accepted: number;
  dropped: number;
};

export interface UILogWebService {
  postGoogleMapsUsage(
    events: GoogleMapsUsageEvent[]
  ): Promise<PostGoogleMapsUsageResponse>;
}

export class RestfulUILogWebService implements UILogWebService {
  restClient: AxiosInstance;

  constructor() {
    this.restClient = axios.create({
      baseURL: config.baseURL,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    this.restClient.interceptors.request.use(injectToken);
    this.restClient.interceptors.response.use(updateToken, autoLogout);
  }

  async postGoogleMapsUsage(
    events: GoogleMapsUsageEvent[]
  ): Promise<PostGoogleMapsUsageResponse> {
    const response = await this.restClient.post<PostGoogleMapsUsageResponse>(
      '/v2/ui-logs/google-maps',
      { events }
    );
    return response.data;
  }
}
